/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import imgSVG from './assets/getting-started-page-app-skeleton.tpl.svg';
import { GettingStartedSkeletonGrid } from './GettingStartedSkeletonCards.tsx';

const customCssStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		margin: 'auto',
		minWidth: '760px',
		maxWidth: '1174px',
	},
});

const skeletonWrapperStyles = css({
	backgroundColor: token('elevation.surface'),
	boxSizing: 'border-box',
	display: 'flex',
	flexDirection: 'column',
	flex: '1 1 auto',
	width: '100%',
	height: '100%',
	maxWidth: '86pc',
	marginLeft: 'auto',
	marginRight: 'auto',
});

export const LegacyGettingStartedPageSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);

export const SolutionComposerGettingStartedPageSkeleton = (): JSX.Element => (
	<div css={skeletonWrapperStyles}>
		<GettingStartedSkeletonGrid />
	</div>
);

export const GettingStartedPageSkeleton: () => JSX.Element = LegacyGettingStartedPageSkeleton;
